function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Colors as BaseColors } from '@doordash/design-language';
import errorAnimationData from './animations/error.lottie';
import foodLoopAnimationData from './animations/food-loop.lottie';
import loadingAnimationData from './animations/loading.lottie';
import successAnimationData from './animations/success.lottie';
export var Sizes = {
  Small: 24,
  Medium: 32,
  Large: 36,
  XLarge: 64,
  XxLarge: 96,
  XxxLarge: 128
};
export var Colors = _objectSpread({
  Dark: BaseColors.SystemBlack,
  Light: BaseColors.SystemWhite,
  Red: BaseColors.SystemRed60,
  Ocean: BaseColors.SystemTeal60
}, BaseColors);
export var States = {
  Loading: 'LOADING/LOADING',
  Success: 'LOADING/SUCCESS',
  Error: 'LOADING/ERROR',
  FoodLoop: 'LOADING/FOOD_LOOP'
};
export var LOADING_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: loadingAnimationData
};
export var SUCCESS_ANIMATION_OPTIONS = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData
};
export var ERROR_ANIMATION_OPTIONS = {
  loop: false,
  autoplay: true,
  animationData: errorAnimationData
};
export var FOOD_LOOP_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: foodLoopAnimationData
};